export function loadHelpList() {
  return {
    type: 'LOAD_HELP_LIST',
  };
}

export function loadHelpListCompletion(error, data) {
  return {
    type: 'LOAD_HELP_LIST_COMPLETION',
    error,
    list: (data && data.listData) || [],
  };
}

export function loadHelp(aid) {
  return {
    type: 'LOAD_HELP',
    aid,
  };
}

export function loadHelpCompletion(aid, error, data) {
  return {
    type: 'LOAD_HELP_COMPLETION',
    aid,
    error,
    data,
  };
}
